import { Alert, AlertProps, styled } from '@mui/material'
import React from 'react'

/**
 * StyledAlert component
 * This component styles the MUI Alert component for banners.
 * It customizes the alert appearance and hides the icon.
 *
 * @param {AlertProps} props - The properties for the alert component.
 * @returns {JSX.Element} The rendered alert component.
 */
const StyledAlert = styled(Alert)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  color: theme.palette.common.white,

  '& .MuiAlert-icon': {
    display: 'none'
  }
}))

/**
 * Banner component
 * This component renders a styled alert banner.
 * It uses MUI's Alert component and allows for custom styling.
 *
 * @param {AlertProps} props - The properties for the alert component.
 * @returns {JSX.Element} The rendered alert component.
 */
const Banner: React.FC<AlertProps> = props => {
  return <StyledAlert {...props} />
}

export default Banner
